module.exports = __webpack_public_path__ + "img/how_con_01.507b08cb.png";